import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "flatpickr/dist/themes/material_blue.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { format } from "date-fns";
import InputMask from "react-input-mask";
import Switch from "react-switch";
import LastModificationAlert from "components/Common/Alert";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  FormFeedback,
  Input,
  Collapse,
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
  Button,
  Spinner,
  Tooltip,
} from "reactstrap";
import {
  FiUser,
  FiEdit3,
  FiChevronDown,
  FiChevronUp,
  FiEye,
} from "react-icons/fi";
import Select from "react-select";
import Spinners from "components/Common/Spinner";
import { useParams } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import config from "config";
import FloatingFormActions from "components/Common/FloatingFormActions";
import IdentificationCard from "./IdentificationCard";
import IdentificationCard2 from "./IdentificationCard2";

import AuditCard from "components/Common/SectionCard";
import DeleteButton from "components/Common/DeleteButtonShow";
import { useTranslation } from "react-i18next";
import { set } from "lodash";
import { Editor } from "@tinymce/tinymce-react";
import CustomTable from "components/Common/hmDynamique";
import DynamicFieldRenderer from "./EditField";
// import IdentificationCard2 from "components/Common/IdentificationCard2"
import { BsFillInfoCircleFill } from "react-icons/bs";
import {
  setPageHistoriqueFxFacturation,
  setPagePaiementFxFacturation,
} from "store/actions";
import { useSelector } from "react-redux";
function FxFacturationDetail() {
  const { t } = useTranslation("");
  // **NOUVEL ÉTAT pour basculer entre show/edit**
  const pageHmHistorique = useSelector(
    (state) => state.FiltreFxFacturation.pageHmHistorique
  );
  const pageHmPaiement = useSelector(
    (state) => state.FiltreFxFacturation.pageHmPaiement
  );
  const backUrl = config.backOffice.url;
  const api = config.backOffice.apiName;
  const [isEditMode, setIsEditMode] = useState(false);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const isEditMode = urlParams.has("edit");
    setIsEditMode(isEditMode);
  }, []);
  const [showFloatingButtons, setShowFloatingButtons] = useState(false);
  const [isFormVisible, setIsFormVisible] = useState(true);
  const formEndRef = useRef(null);
  const editorRef = useRef(null);

  let currentLeftSideBar = localStorage.getItem("leftSideBar");
  const [leftPosition, setLeftPosition] = useState(
    localStorage.getItem("leftSideBar") === "icon" ? true : false
  );
  const [actionHelper, setActionHelper] = useState({});
  // Fonction pour recupérer l'aide contextuelle pour une action donnée
  const getActionHelper = async (action) => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/fx_facturations/helper`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        setActionHelper(data);
      }
    } catch (error) {
      console.error("Error fetching action helper:", error);
    }
  };
  function sanitizeSelector(str) {
    // Remplace les espaces et caractères non valides par des underscores
    let sanitized = str.replace(/[^a-zA-Z0-9_-]/g, "_");
    // Si la chaîne commence par un chiffre, ajoute un underscore au début
    if (/^\d/.test(sanitized)) {
      sanitized = "_" + sanitized;
    }
    return sanitized;
  }
  //tooltip states
  const [tooltipOpen, setTooltipOpen] = useState({});

  const toggleTooltip = (key) => {
    setTooltipOpen((prev) => ({ ...prev, [key]: !prev[key] }));
  };
  // Vérifier périodiquement (solution simple mais moins optimale)
  setInterval(() => {
    const newValue = localStorage.getItem("leftSideBar");
    if (newValue !== currentLeftSideBar) {
      currentLeftSideBar = newValue;
      const isIcon = newValue === "icon";
      setLeftPosition(isIcon);
    }
  }, 100); // Vérifier toutes les 100ms

  const [accordionStates, setAccordionStates] = useState({});

  // Fonction pour changer l'état d'une clé spécifique
  const toggleAccordion = (key) => {
    setAccordionStates((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };
  const [isAccordionOpen, setIsAccordionOpen] = useState(true);
  const toggleAccordion0 = () => {
    setIsAccordionOpen(!isAccordionOpen);
  };
  const [isAccordionOpen1, setIsAccordionOpen1] = useState(true);
  const toggleAccordion1 = () => {
    setIsAccordionOpen1(!isAccordionOpen1);
  };
  const [isAccordionOpen2, setIsAccordionOpen2] = useState(true);
  const toggleAccordion2 = () => {
    setIsAccordionOpen2(!isAccordionOpen2);
  };
  const [isAccordionOpen3, setIsAccordionOpen3] = useState(true);
  const toggleAccordion3 = () => {
    setIsAccordionOpen3(!isAccordionOpen3);
  };
  const [isAccordionOpen4, setIsAccordionOpen4] = useState(true);
  const toggleAccordion4 = () => {
    setIsAccordionOpen4(!isAccordionOpen4);
  };
  const [isAccordionOpen5, setIsAccordionOpen5] = useState(true);
  const toggleAccordion5 = () => {
    setIsAccordionOpen5(!isAccordionOpen5);
  };
  const [wait, setWait] = useState(1000);

  let { id } = useParams();
  const navigate = useNavigate();
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    const sectionKeys = Object.keys(Country.detail_fx_facturation);
    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        {/* <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            to="#details"
            onClick={() => handleTabClick("details")}
          >
            {t("Détails")}
          </NavLink>
        </NavItem> */}
        {sectionKeys.map((section) => (
          <NavItem key={section}>
            <NavLink
              style={navStyle}
              className={`nav-link ${activeTab === section ? "active" : ""}`}
              onClick={() => handleTabClick(section)}
            >
              {section}
            </NavLink>
          </NavItem>
        ))}
        {!isEditMode &&
          Country?.hm_accessibles?.map((key, index) =>
            key === "hm_fx_historiques" ? (
              <NavItem key={index}>
                <NavLink
                  style={navStyle}
                  className={`nav-link ${
                    activeTab === "hm_fx_historiques" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("hm_fx_historiques")}
                >
                  {!loading ? (
                    fxHistorique?.title
                  ) : (
                    <>
                      <h5 className="card-title placeholder-glow">
                        <span
                          style={{ height: "1em" }}
                          className="placeholder col-6"
                        ></span>
                      </h5>
                    </>
                  )}
                </NavLink>
              </NavItem>
            ) : null
          )}
        {!isEditMode &&
          Country?.hm_accessibles?.map((key, index) =>
            key === "hm_fx_paiements" ? (
              <NavItem key={index}>
                <NavLink
                  style={navStyle}
                  className={`nav-link ${
                    activeTab === "hm_fx_paiements" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("hm_fx_paiements")}
                >
                  {!loading ? (
                    fxPaiement?.title
                  ) : (
                    <>
                      <h5 className="card-title placeholder-glow">
                        <span
                          style={{ height: "1em" }}
                          className="placeholder col-6"
                        ></span>
                      </h5>
                    </>
                  )}
                </NavLink>
              </NavItem>
            ) : null
          )}
      </Nav>
    );
  };
  const tableaustyles = {
    background: "#3c88c8",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
  };

  const colStyle = {
    width: "15em",
    whiteSpace: "nowrap",
    display: "inline-block",
    paddingTop: "1px",
    color: "#7f7f7f",
    verticalAlign: "middle",
    display: "flex",
    alignItems: "center",
  };
  const layout = localStorage.getItem("layoutMode");

  const FIELD_DIMENSIONS = {
    height: "26px",
    minHeight: "26px",
    fontSize: "0.75rem",
    padding: "4px 6px",
    borderRadius: "4px",
    borderWidth: "1px",
  };
  const styleSelect = (isRequired) => ({
    control: (base, state) => ({
      ...base,
      height: FIELD_DIMENSIONS.height,
      minHeight: FIELD_DIMENSIONS.minHeight,
      borderRadius: FIELD_DIMENSIONS.borderRadius,
      // ✅ CONTOURS TRÈS SUBTILS
      border: isRequired
        ? "1px solid #dc3545"
        : state.isFocused
        ? "1px solid #80bdff" // ✅ Bleu très pâle
        : "1px solid white", // ✅ Gris ultra-subtil
      // ✅ PAS DE SHADOW ou shadow très légère
      boxShadow: state.isFocused
        ? isRequired
          ? "0 0 0 0.2rem rgba(220, 53, 69, 0.15)" // ✅ Shadow plus fine
          : "0 0 0 0.2rem rgba(0, 123, 255, 0.15)" // ✅ Shadow plus fine
        : "none",
      fontSize: FIELD_DIMENSIONS.fontSize,
      transition: "all 0.15s ease-in-out",
      backgroundColor: "#fff",
      "&:hover": {
        borderColor: isRequired
          ? "#dc3545"
          : state.isFocused
          ? "#80bdff"
          : "#c6cdd4", // ✅ Hover très doux
      },
    }),
    valueContainer: (base) => ({
      ...base,
      padding: FIELD_DIMENSIONS.padding, // ✅ Même padding que les inputs
      height: `calc(${FIELD_DIMENSIONS.height} - 2px)`, // -2px pour les bordures
      display: "flex",
      alignItems: "center",
    }),
    input: (base) => ({
      ...base,
      margin: "0",
      padding: "0",
      fontSize: FIELD_DIMENSIONS.fontSize, // ✅ Cohérence taille police
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: FIELD_DIMENSIONS.fontSize,
      color: "#6c757d", // ✅ Même couleur placeholder que inputs
      opacity: 0.7,
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: FIELD_DIMENSIONS.fontSize,
      color: layout === "dark" ? "#fff" : "#212529", // ✅ Même couleur texte
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "6px", // ✅ Réduit pour cohérence
      color: "#6c757d",
      svg: {
        width: "13px", // ✅ Plus petit pour cohérence
        height: "13px",
      },
      "&:hover": {
        color: isRequired ? "#dc3545" : "#007bff",
      },
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "2px",
      color: "#6c757d",
      svg: {
        width: "10px",
        height: "10px",
      },
      "&:hover": {
        color: "#dc3545",
      },
    }),
    // ✅ Styles pour le menu déroulant (cohérence)

    menu: (base) => ({
      ...base,
      borderRadius: FIELD_DIMENSIONS.borderRadius,
      border: "1px solid #e9ecef",
      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
      fontSize: FIELD_DIMENSIONS.fontSize,
      zIndex: "2147483647",
      marginTop: "-6px", // Au lieu de la valeur par défaut (8px)
      marginBottom: "0px",
    }),
    option: (base, state) => ({
      ...base,
      zIndex: 2147483647,
      fontSize: FIELD_DIMENSIONS.fontSize,
      padding: "6px 12px", // ✅ Padding cohérent
      backgroundColor: state.isSelected
        ? "#555B21"
        : state.isFocused
        ? "#f8f9fa"
        : "white",
      color: state.isSelected ? "#fff" : layout === "dark" ? "#fff" : "#212529",
      "&:hover": {
        backgroundColor: state.isSelected
          ? isRequired
            ? "#dc3545"
            : "#007bff"
          : "#f8f9fa",
      },
    }),
  });
  const inputStyle = (isRequired) => ({
    height: FIELD_DIMENSIONS.height, // ✅ Hauteur fixe
    minHeight: FIELD_DIMENSIONS.minHeight, // ✅ Hauteur minimale
    borderRadius: FIELD_DIMENSIONS.borderRadius,
    backgroundColor: "#fff",
    transition: "all 0.2s ease",
    fontSize: FIELD_DIMENSIONS.fontSize,
    padding: FIELD_DIMENSIONS.padding, // ✅ Padding uniforme
    boxShadow: isRequired
      ? "0 1px 2px rgba(220,53,69,0.15)"
      : "0 1px 2px rgba(0,0,0,0.06)",
    border: isRequired ? "1px solid #dc3545" : "1px solid #e9ecef",
    lineHeight: "1.2", // ✅ Hauteur de ligne
    display: "flex", // ✅ Flexbox pour centrage
    alignItems: "center", // ✅ Centrage vertical
  });
  const inputStyleDate = (isRequired) => ({
    height: FIELD_DIMENSIONS.height, // ✅ Hauteur fixe
    minHeight: FIELD_DIMENSIONS.minHeight, // ✅ Hauteur minimale
    borderRadius: FIELD_DIMENSIONS.borderRadius,
    backgroundColor: "#fff",
    transition: "all 0.2s ease",
    fontSize: FIELD_DIMENSIONS.fontSize,
    padding: FIELD_DIMENSIONS.padding, // ✅ Padding uniforme
    boxShadow: isRequired
      ? "0 1px 2px rgba(220,53,69,0.15)"
      : "0 1px 2px rgba(0,0,0,0.06)",
    border: isRequired ? "1px solid #dc3545" : "1px solid #e9ecef",
    lineHeight: "1.2", // ✅ Hauteur de ligne
    alignItems: "center", // ✅ Centrage vertical
  });
  const token = localStorage.getItem("auth_token_" + api);
  const [OffreMetierData, setOffreMetier] = useState([]);
  const [Country, setCountry] = useState([]); // Ajout pour mode show
  const sectionKeys = Object.keys(Country?.detail_fx_facturation || {});

  const [activeTab, setActiveTab] = useState("");
  const hasInitializedRef = useRef(false);
  useEffect(() => {
    if (!hasInitializedRef.current && Country?.detail_fx_facturation) {
      const keys = Object.keys(Country.detail_fx_facturation);
      if (keys.length > 0) {
        setActiveTab(keys[0]);
      }
      hasInitializedRef.current = true;
    }
  }, [Country]);
  // Map display labels to stable internal ids to avoid comparing locale text in logic
  const FIELD_LABEL_MAP = {
    [t("Défaut")]: "defaut",
    [t("Par défaut")]: "defaut",
    [t("UE")]: "ue",
    [t("Nom EN")]: "nom_en",
    [t("Nom EN")]: "nom_en",
    [t("Nom FR")]: "nom_fr",
    [t("Statut EN")]: "statut_en",
  };
  const getFieldId = (key) => FIELD_LABEL_MAP[key] || key;
  const [btnsecondary1, setBtnsecondary1] = useState(false);

  const requiredFields = ["Nom FR", "Défaut", "UE"];
  // HM
  const [fxHistorique, setFxHistorique] = useState([]);
  const getFxHistorique = async () => {
    try {
      await fetch(
        `https://www.fluxod.com/${api}/fx_facturations/${id}/hm_fx_historiques`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setFxHistorique(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const [fxPaiement, setFxPaiement] = useState([]);
  const getFxPaiement = async () => {
    try {
      await fetch(
        `https://www.fluxod.com/${api}/fx_facturations/${id}/hm_fx_paiements`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setFxPaiement(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  // fin HM
  const getData = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/fx_facturations/${id}/edit`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 403) {
        navigate(`${backUrl}/forbidden`);
      }
      if (response.status === 500) {
        navigate(`${backUrl}/error`);
      }
      if (response.status === 203) {
        navigate(`${backUrl}/error404`);
      }
      if (response.status === 401) {
        localStorage.removeItem("auth_token");
        localStorage.removeItem("authUser");
        localStorage.removeItem("sideBar");
        navigate(`${backUrl}/login`);
        window.location.reload(false);
      }

      const OffreMetierData = await response.json();
      setOffreMetier(OffreMetierData);

      // Charger les données de référence
      await Promise.all([
        getTermes(),
        getPeriodes(),
        getIndexation(),
        getFxUser(),
      ]);
    } catch (error) {
      console.error(error);
    }
  };

  // **Fonction getData POUR MODE SHOW**
  const getDataShow = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/fx_facturations/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 403) {
        navigate(`${backUrl}/forbidden`);
      }
      if (response.status === 500) {
        navigate(`${backUrl}/error`);
      }
      if (response.status === 203) {
        navigate(`${backUrl}/error404`);
      }
      if (response.status === 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("sideBar");
        navigate(`${backUrl}/login`);
        window.location.reload(false);
      }

      const CountryData = await response.json();
      setCountry(CountryData);
      {
        CountryData?.hm_accessibles?.map(async (key, index) =>
          key === "hm_fx_historiques"
            ? await getFxHistorique()
            : key === "hm_fx_paiements"
            ? await getFxPaiement()
            : null
        );
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const [periodes, setPeriodes] = useState({ data: [] });
  const getPeriodes = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/fx_facturations/periodes`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setPeriodes(data);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const renderPeriodOptions = () => {
    return [
      {
        options: periodes?.result.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.value,
        })),
      },
    ];
  };

  const [termes, setTermes] = useState({ data: [] });
  const getTermes = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/fx_facturations/termes`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setTermes(data);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const renderTermesOptions = () => {
    return [
      {
        options:
          termes.result?.map((dataItem) => ({
            label: dataItem.label,
            value: dataItem.value,
          })) || [],
      },
    ];
  };
  const [fxUser, setFxUser] = useState({ data: [] });
  const getFxUser = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/fx_facturations/fx_users`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setFxUser(data);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const renderUsersOptions = () => {
    return [
      {
        options:
          fxUser.result?.map((dataItem) => ({
            label: dataItem.label,
            value: dataItem.value,
          })) || [],
      },
    ];
  };
  const [indexation, setIndexation] = useState({ data: [] });
  const getIndexation = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/fx_facturations/fx_indexations`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setIndexation(data);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const renderIndexationOptions = () => {
    return [
      {
        options: indexation.result.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.value,
        })),
      },
    ];
  };

  const OuiNon = {
    data: [
      { id: 1, label: "Oui" },
      { id: 2, label: "Non" },
    ],
  };

  const renderYesNoOptions = () => {
    return [
      {
        options: OuiNon.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {t("Non")}
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {t("Oui")}
      </div>
    );
  };
  const [cgu, setCgu] = useState("");
  const handleCguChange = (event) => {
    const newFile = event.target.files[0]; // Récupère le nouveau fichier
    if (newFile) {
      setCgu(newFile);
    } else {
      setCgu(null);
      console.log("Aucun fichier sélectionné");
    }
  };
  const [contrat, setContrat] = useState("");
  const handleContratChange = (event) => {
    const newFile = event.target.files[0]; // Récupère le nouveau fichier
    if (newFile) {
      setContrat(newFile);
    } else {
      setContrat(null);
      console.log("Aucun fichier sélectionné");
    }
  };
  // Observer pour détecter si les boutons sont visibles
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setShowFloatingButtons(!entry.isIntersecting);
      },
      {
        threshold: 0.1,
        rootMargin: "0px 0px -100px 0px", // Déclenche avant que l'élément disparaisse
      }
    );

    if (formEndRef.current) {
      observer.observe(formEndRef.current);
    }

    return () => observer.disconnect();
  }, [isEditMode, loading, activeTab]);
  const validationSchema = Yup.object({
    // Ajouter validation si nécessaire
  });

  const generateInitialValues = (data) => {
    const initialValues = {};

    if (!data || typeof data !== "object") {
      return initialValues;
    }

    // Parcourir toutes les sections principales (Données Client, Données Vendeur, etc.)
    Object.entries(data).forEach(([section, sectionData]) => {
      if (sectionData && typeof sectionData === "object") {
        // Parcourir toutes les sous-sections de chaque section
        Object.entries(sectionData).forEach(([subSection, subSectionData]) => {
          if (subSectionData && typeof subSectionData === "object") {
            // Parcourir tous les champs de chaque sous-section
            Object.entries(subSectionData).forEach(([fieldKey, fieldValue]) => {
              // Gérer les cas où la valeur est un objet avec une propriété "value" et "label"
              if (
                fieldValue &&
                typeof fieldValue === "object" &&
                "value" in fieldValue &&
                "label" in fieldValue
              ) {
                // Liste des valeurs de label qui indiquent un champ boolean
                const booleanLabels = ["Oui", "Yes", "Non", "No"];

                if (booleanLabels.includes(fieldValue.label)) {
                  // Pour les champs booléens, utiliser la valeur (0 ou 1)
                  initialValues[fieldKey] = fieldValue.value || 0;
                } else {
                  // Pour les autres champs avec label/value (comme Select)
                  initialValues[fieldKey] = fieldValue;
                }
              } else if (
                fieldValue &&
                typeof fieldValue === "object" &&
                "value" in fieldValue
              ) {
                // Objet avec seulement "value" (pas de label)
                initialValues[fieldKey] = fieldValue.value || "";
              } else {
                // Valeur simple (string, number, etc.)
                initialValues[fieldKey] = fieldValue ?? "";
              }
            });
          }
        });
      }
    });

    return initialValues;
  };

  const formik = useFormik({
    initialValues: generateInitialValues(
      OffreMetierData?.detail_fx_facturation
    ),

    validationSchema: validationSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/fx_facturations/${id}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              id: id,
              label_facture: values[t("Label")],
              nom_du_client: values[t("Nom")],
              facturation_auto:
                values[t("Facturation auto ?")] ||
                values[t("Facturation auto ?")] == true
                  ? 1
                  : 2, // OUI/NON
              date: values[t("Date de démarrage")],
              date_historisation: values[t("Date de démarrage")],
              periode_value:
                values[t("Périodicité de facturation")]?.value || null,
              terme_value: values[t("Terme")]?.value || null,
              report_facture:
                values[t("Report facture")] ||
                values[t("Report facture")] == true
                  ? 1
                  : 2, // OUI/NON
              montant_minimum: values[t("Montant minimum HT")],
              tva: values[t("TVA")],
              prix_jourhomme: values[t("Prix jour/homme")],
              // "contrat": => fichier laisser vide pour le moment ,
              date_contrat: values[t("Date contrat")],
              // "cgu": ,
              fx_indexation_id: values[t("Indice contrat")]?.value || null,
              fx_indexation2_id: values[t("Indice précédent")]?.value || null,
              fx_indexation3_id: values[t("Indice courant")]?.value || null,

              auto: values[t("Paiement en ligne ?")], // OUI/NON
              paiement_delai: values[t("Délai de paiement (j.)")],
              paiement_rappel: values[t("Rappel de paiement")],
              blocage_auto:
                values[t("Blocage auto")] || values[t("Blocage auto")] == true
                  ? 1
                  : 2, // OUI/NON
              bloque:
                values[t("Application bloquée ?")] ||
                values[t("Application bloquée ?")] == true
                  ? 1
                  : 2, // OUI/NON
              // lien_ogone: values[t("Lien Ogone")],
              // login_ogone: values[t("Login Ogone")],

              adresse: values[t("Adresse")],
              code_postal: values[t("Code postal")],
              ville: values[t("Ville")],
              pays: values[t("Pays")],
              fx_user_id: values[t("Contact de facturation")]?.value || null,
              numero_tva: values[t("Numéro TVA")],
              numero_siren: values[t("Numéro SIREN")],
              // ville_rcs: values[t("Ville RCS")],
              // telephone_client: values[t("Téléphone client")],
              // sms:
              //   values[t("Alerte SMS")] || values[t("Alerte SMS")] == true
              //     ? 1
              //     : 2, // OUI/NON
              // telephone: values[t("Téléphone SMS")],

              destinataires: values[t("Email valideurs")],
              // logo_de_facture: values[t("Logo de facture")],
              informations_prestataire: values[t("Informations prestataire")],
              complementaires_facture:
                values[t("Informations complémentaires")],
              footer_pdf: values[t("Footer PDF")],
              signature_email: values[t("Signature email")],

              // cheque_ordre: values[t("Chèque (ordre)")],
              // cheque_adresse: values[t("Chèque (adresse)")],
              virement_rib: values[t("Virement (RIB)")],

              // webservice_user: values[t("Webservice user")],
              // webservice_pass: values[t("Webservice pass")],
            }),
          }
        );

        if (response.ok) {
          toast.success(t("Mis à jour avec succès!"));
          setIsEditMode(false);
          await getDataShow();
          await getData();
        } else {
          console.error("POST request failed");
          const responseData = await response.json();
          if (responseData?.message_validation) {
            responseData.message_validation.forEach((error) =>
              toast.error(error)
            );
          } else {
            toast.error("An error occurred");
          }
        }
      } catch (error) {
        console.error("Erreur:", error);
        toast.error(t("Erreur lors de la mise à jour"));
      }
    },
  });
  console.log("for", formik.values);

  const [categorie, setCategorie] = useState({ data: [] });
  const getCategories = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/fx_facturations/categorie_motif_affaire_perdues`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setCategorie(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderCategoriesOptions = () => {
    return [
      {
        options: categorie.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.value,
        })),
      },
    ];
  };
  // **Fonction pour basculer les modes**
  const toggleEditMode = () => {
    if (!isEditMode) {
      setIsEditMode(true);
      const keys = Object.keys(Country.detail_fx_facturation);
      if (activeTab == "hm_fx_historiques" || activeTab == "hm_fx_paiements") {
        setActiveTab(keys[0]);
      }
    } else {
      setIsEditMode(false);
      getDataShow(); // Recharger données show
    }
  };
  const [mandatory_fields, setMandatory] = useState([]);
  const getMandatory = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/fx_facturations/mandatory_fields`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setMandatory(data?.mandatory_fields || []);
        });
    } catch (error) {
      console.log(error);
    }
  };

  // Fonction pour vérifier si un champ est obligatoire
  const isRequiredField = (key) => mandatory_fields.includes(key);
  // **useEffect INITIAL**
  useEffect(() => {
    setLoading(true);
    // Charger en mode show par défaut
    getDataShow();
    getData();
    getMandatory();
    document.title = `${t("FX Paramètres de facturation")} | ${t(
      "Détails"
    )} | Fluxod`;
  }, []);

  const handleGoBack = () => {
    window.history.back();
  };
  const handleDropDownActionsClick = (action) => {
    console.log("Action:", action);
  };

  if (loading) {
    return (
      <div className="text-center mt-5">
        <Spinners setLoading={setLoading} color="#3c88c8" />
      </div>
    );
  }
  let linkState = { active: "" };

  if (activeTab == "details") {
    linkState.active = "details";
  } else if (activeTab == "contact") {
    linkState.active = "contact";
  } else {
    linkState.active = "details";
  }
  return (
    <>
      <div className="page-content">
        <Row>
          <Col xs="12">
            {!isEditMode ? (
              <>
                <Card>
                  <CardBody className="border-bottom">
                    <div className="d-flex align-items-center">
                      <h5
                        className="mb-0 card-title flex-grow-1"
                        style={{ fontWeight: "bold", display: "flex" }}
                      >
                        <Link
                          // to={`${backUrl}/fx_facturations/`}
                          style={{
                            color: "#555B21",
                            textDecoration: "underline !important",
                          }}
                        >
                          {t("FX Paramètres de facturation")}{" "}
                        </Link>{" "}
                        <i className="bx bx-caret-right"></i>{" "}
                        {!loading ? (
                          Country.sil
                        ) : (
                          <>
                            <span
                              className="placeholder col-3"
                              style={{ height: "1em" }}
                            ></span>
                          </>
                        )}
                      </h5>
                    </div>

                    <div className="d-flex justify-content-end">
                      <div className="d-flex align-items-end">
                        {Country.can_edit ? (
                          <Link
                            onClick={toggleEditMode}
                            state={linkState}
                            className="btn btn-sm btn-primary"
                          >
                            <i className="bx bx-edit-alt"></i> {t("Modifier")}
                          </Link>
                        ) : null}
                        &nbsp; &nbsp;
                        {Country.can_destroy ? (
                          <DeleteButton
                            url={`https://www.fluxod.com/${api}/fx_facturations/${id}`}
                          />
                        ) : null}
                        {Country?.actions?.length > 0 ? (
                          <>
                            <>
                              &nbsp; &nbsp;
                              <Dropdown
                                isOpen={btnsecondary1}
                                toggle={() => setBtnsecondary1(!btnsecondary1)}
                              >
                                <DropdownToggle
                                  tag="button"
                                  className="btn btn-sm btn-secondary"
                                >
                                  Actions <i className="mdi mdi-chevron-down" />
                                </DropdownToggle>
                                <DropdownMenu>
                                  {Country?.actions.map((value, index) => (
                                    <>
                                      <DropdownItem
                                        onClick={() =>
                                          handleDropDownActionsClick(
                                            value.action
                                          )
                                        }
                                      >
                                        {value.label}
                                      </DropdownItem>
                                    </>
                                  ))}
                                </DropdownMenu>
                              </Dropdown>
                            </>
                          </>
                        ) : null}
                      </div>
                    </div>
                  </CardBody>
                  {CustomNavTabs()}
                  <CardBody>
                    {!loading ? (
                      <div>
                        {sectionKeys.map(
                          (section) =>
                            activeTab === section && (
                              <div key={section} style={{ marginTop: "1rem" }}>
                                <Row>
                                  {Object.entries(
                                    Country?.detail_fx_facturation[section]
                                  ).map(([subSection, subData]) => (
                                    <>
                                      {}
                                      {subSection !=
                                      t("Données du prestataire") ? (
                                        <Col sm="6" key={subSection}>
                                          <IdentificationCard
                                            title={subSection}
                                            details={subData}
                                            isAccordionOpen={
                                              accordionStates[subSection] ??
                                              true
                                            }
                                            setIsAccordionOpen={() =>
                                              toggleAccordion(subSection)
                                            }
                                            tooltips={actionHelper?.result}
                                          />
                                        </Col>
                                      ) : (
                                        <Col sm="12" key={subSection}>
                                          <IdentificationCard2
                                            title={subSection}
                                            details={subData}
                                            isAccordionOpen={
                                              accordionStates[subSection] ??
                                              true
                                            }
                                            setIsAccordionOpen={() =>
                                              toggleAccordion(subSection)
                                            }
                                            tooltips={actionHelper?.result}
                                          />
                                        </Col>
                                      )}
                                    </>
                                  ))}
                                </Row>
                              </div>
                            )
                        )}
                      </div>
                    ) : (
                      <Spinners setLoading={setLoading} />
                    )}{" "}
                    <div ref={formEndRef} style={{ height: "1px" }} />
                    {activeTab != "hm_fx_historiques" &&
                      activeTab != "hm_fx_paiements" && (
                        <div style={{ visibility: "hidden" }}>
                          <FloatingFormActions
                            showFloatingButtons={showFloatingButtons}
                            leftPosition={leftPosition}
                            onCancel={toggleEditMode}
                            onSubmit={formik.handleSubmit}
                            isSubmitting={formik.isSubmitting}
                            disabled={!formik.isValid}
                            submitText={t("Enregistrer les modifications")}
                          />
                        </div>
                      )}
                    {activeTab === "hm_fx_historiques" && (
                      <div className="table-responsive">
                        {!loading ? (
                          <>
                            <CustomTable
                              data={fxHistorique}
                              backUrl={backUrl}
                              api={api}
                              screen={""}
                              setPage={setPageHistoriqueFxFacturation}
                              num={pageHmHistorique}
                            />
                          </>
                        ) : (
                          <Spinners setLoading={setLoading} />
                        )}
                      </div>
                    )}
                    {activeTab === "hm_fx_paiements" && (
                      <div className="table-responsive">
                        {!loading ? (
                          <>
                            <CustomTable
                              data={fxPaiement}
                              backUrl={backUrl}
                              api={api}
                              screen={""}
                              setPage={setPagePaiementFxFacturation}
                              num={pageHmPaiement}
                            />
                          </>
                        ) : (
                          <Spinners setLoading={setLoading} />
                        )}
                      </div>
                    )}
                  </CardBody>
                </Card>
              </>
            ) : (
              <>
                <Card>
                  <CardBody className="border-bottom">
                    <div className="d-flex align-items-center">
                      <h5
                        className="mb-0 card-title flex-grow-1"
                        style={{ fontWeight: "bold", display: "flex" }}
                      >
                        <Link
                          // to={`${backUrl}/fx_facturations/`}
                          style={{
                            color: "#555B21",
                            textDecoration: "underline !important",
                          }}
                        >
                          {t("FX Paramètres de facturation")}
                        </Link>
                        <i className="bx bx-caret-right"></i>
                        {!loading ? (
                          OffreMetierData.sil
                        ) : (
                          <>
                            <span
                              className="placeholder col-3"
                              style={{ height: "1em" }}
                            ></span>
                          </>
                        )}
                      </h5>
                    </div>
                    <div
                      className="d-flex justify-content-end"
                      style={{ visibility: isEditMode ? "hidden" : "visible" }}
                    >
                      <div className="d-flex align-items-end">
                        {Country.can_edit ? (
                          <Link
                            onClick={toggleEditMode}
                            state={linkState}
                            className="btn btn-sm btn-info"
                            style={{ backgroundColor: "#004aff" }}
                          >
                            <i className="bx bx-edit-alt"></i> {t("Modifier")}
                          </Link>
                        ) : null}
                        &nbsp; &nbsp;
                        {Country.can_destroy ? (
                          <DeleteButton
                            url={`https://www.fluxod.com/${api}/fx_facturations/${id}`}
                          />
                        ) : null}
                        {Country?.actions?.length > 0 ? (
                          <>
                            <>
                              &nbsp; &nbsp;
                              <Dropdown
                                isOpen={btnsecondary1}
                                toggle={() => setBtnsecondary1(!btnsecondary1)}
                              >
                                <DropdownToggle
                                  tag="button"
                                  className="btn btn-sm btn-secondary"
                                >
                                  Actions <i className="mdi mdi-chevron-down" />
                                </DropdownToggle>
                                <DropdownMenu>
                                  {Country?.actions.map((value, index) => (
                                    <>
                                      <DropdownItem
                                        onClick={() =>
                                          handleDropDownActionsClick(
                                            value.action
                                          )
                                        }
                                      >
                                        {value.label}
                                      </DropdownItem>
                                    </>
                                  ))}
                                </DropdownMenu>
                              </Dropdown>
                            </>
                          </>
                        ) : null}
                      </div>
                    </div>
                  </CardBody>
                  {CustomNavTabs()}
                  <CardBody>
                    {sectionKeys.map(
                      (section) =>
                        activeTab === section && (
                          <div key={section} style={{ marginTop: "1rem" }}>
                            {!loading ? (
                              <Row>
                                {Object.entries(
                                  OffreMetierData?.detail_fx_facturation?.[
                                    section
                                  ] || {}
                                ).map(([subSection, subData]) => (
                                  <Col
                                    sm={
                                      subSection != t("Données du prestataire")
                                        ? "6"
                                        : "12"
                                    }
                                    key={subSection}
                                  >
                                    <Card
                                      className="shadow-sm border-0 overflow-hidden mb-3"
                                      style={{ borderRadius: "12px" }}
                                    >
                                      {/* En-tête cliquable */}
                                      <div
                                        className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                        style={{
                                          background: "#555B21",
                                          letterSpacing: "0.5px",
                                          cursor: "pointer",
                                          userSelect: "none",
                                        }}
                                        onClick={() =>
                                          toggleAccordion(subSection)
                                        }
                                      >
                                        <div className="d-flex align-items-center">
                                          {/* <FiUser size={16} className="me-2" /> */}
                                          <span style={{ fontSize: "0.82rem" }}>
                                            {subSection}
                                          </span>
                                        </div>
                                        {accordionStates[subSection] ? (
                                          <FiChevronUp size={16} />
                                        ) : (
                                          <FiChevronDown size={16} />
                                        )}
                                      </div>

                                      {/* Contenu repliable */}
                                      <Collapse
                                        isOpen={
                                          accordionStates[subSection] ?? true
                                        }
                                      >
                                        <CardBody className="p-0">
                                          <div
                                            className="fields-container"
                                            style={{ paddingBottom: "8px" }}
                                          >
                                            {subSection ===
                                            "Données du prestataire"
                                              ? // Layout deux colonnes pour "Données du prestataire"
                                                (() => {
                                                  const entries =
                                                    Object.entries(
                                                      subData || {}
                                                    );
                                                  const groupedEntries = [];
                                                  for (
                                                    let i = 0;
                                                    i < entries.length;
                                                    i += 2
                                                  ) {
                                                    groupedEntries.push(
                                                      entries.slice(i, i + 2)
                                                    );
                                                  }

                                                  return groupedEntries.map(
                                                    (group, groupIndex) => (
                                                      <Row
                                                        key={groupIndex}
                                                        className="g-0"
                                                      >
                                                        {group.map(
                                                          (
                                                            [key, value],
                                                            itemIndex
                                                          ) => {
                                                            const isRequired =
                                                              isRequiredField(
                                                                key
                                                              );
                                                            const safeKey =
                                                              sanitizeSelector(
                                                                key.replace(
                                                                  /([:])/g,
                                                                  "\\$1"
                                                                )
                                                              );
                                                            return (
                                                              <Col
                                                                key={key}
                                                                xs={12}
                                                                lg={6}
                                                                className="field-item px-2 py-1"
                                                                style={{
                                                                  backgroundColor:
                                                                    "white",
                                                                  transition:
                                                                    "all 0.15s ease",
                                                                  borderLeft:
                                                                    isRequired
                                                                      ? "3px solid #dc3545"
                                                                      : "3px solid transparent",
                                                                  position:
                                                                    "relative",
                                                                }}
                                                                onMouseEnter={(
                                                                  e
                                                                ) => {
                                                                  if (
                                                                    isRequired
                                                                  ) {
                                                                    e.currentTarget.style.backgroundColor =
                                                                      "#ffe6e6";
                                                                    e.currentTarget.style.borderLeftColor =
                                                                      "#dc3545";
                                                                  } else {
                                                                    e.currentTarget.style.backgroundColor =
                                                                      "#e3f2fd";
                                                                    e.currentTarget.style.borderLeftColor =
                                                                      "#007bff";
                                                                  }
                                                                }}
                                                                onMouseLeave={(
                                                                  e
                                                                ) => {
                                                                  e.currentTarget.style.backgroundColor =
                                                                    "white";
                                                                  if (
                                                                    isRequired
                                                                  ) {
                                                                    e.currentTarget.style.borderLeftColor =
                                                                      "#dc3545";
                                                                  } else {
                                                                    e.currentTarget.style.borderLeftColor =
                                                                      "transparent";
                                                                  }
                                                                }}
                                                              >
                                                                {/* Ligne de séparation */}
                                                                {(groupIndex >
                                                                  0 ||
                                                                  itemIndex >
                                                                    0) && (
                                                                  <div
                                                                    className="field-separator"
                                                                    style={{
                                                                      position:
                                                                        "absolute",
                                                                      top: "0",
                                                                      left: "0",
                                                                      right: 0,
                                                                      height:
                                                                        "1px",
                                                                      background:
                                                                        "linear-gradient(90deg, #e9ecef 0%, #e9ecef 20%, #e9ecef 100%, #e9ecef 100%)",
                                                                    }}
                                                                  />
                                                                )}

                                                                <Row className="align-items-center g-1">
                                                                  <Col
                                                                    xs={12}
                                                                    md={4}
                                                                    className="field-label"
                                                                  >
                                                                    <div className="d-flex align-items-center small text-muted">
                                                                      <span
                                                                        className={`fw-medium`}
                                                                        style={{
                                                                          fontSize:
                                                                            "0.8rem",
                                                                          letterSpacing:
                                                                            "0.2px",
                                                                        }}
                                                                        id={`Tooltip-${safeKey}`}
                                                                      >
                                                                        {key}
                                                                      </span>
                                                                      {actionHelper
                                                                        ?.result?.[
                                                                        key
                                                                      ] && (
                                                                        <>
                                                                          <span
                                                                            style={{
                                                                              display:
                                                                                "inline-flex",
                                                                              padding:
                                                                                "6px", // élargit la zone autour de l'icône
                                                                              cursor:
                                                                                "pointer",
                                                                              alignItems:
                                                                                "center",
                                                                              justifyContent:
                                                                                "center",
                                                                            }}
                                                                            id={`Info-${safeKey}`}
                                                                          >
                                                                            <BsFillInfoCircleFill
                                                                              size={
                                                                                14
                                                                              }
                                                                              className="text-info"
                                                                            />
                                                                          </span>
                                                                          <Tooltip
                                                                            placement="right"
                                                                            isOpen={
                                                                              tooltipOpen[
                                                                                key
                                                                              ]
                                                                            }
                                                                            target={`Info-${safeKey}`}
                                                                            toggle={() =>
                                                                              toggleTooltip(
                                                                                key
                                                                              )
                                                                            }
                                                                            delay={{
                                                                              show: 0,
                                                                              hide: 100,
                                                                            }}
                                                                          >
                                                                            {
                                                                              actionHelper
                                                                                ?.result[
                                                                                key
                                                                              ]
                                                                            }
                                                                          </Tooltip>
                                                                        </>
                                                                      )}
                                                                      <span className="ms-1 text-primary">
                                                                        :
                                                                      </span>
                                                                    </div>
                                                                  </Col>

                                                                  <Col
                                                                    xs={12}
                                                                    md={8}
                                                                    className="field-input"
                                                                  >
                                                                    <DynamicFieldRenderer
                                                                      fieldKey={
                                                                        key
                                                                      }
                                                                      formik={
                                                                        formik
                                                                      }
                                                                      isRequired={
                                                                        isRequired
                                                                      }
                                                                      inputStyle={
                                                                        inputStyle
                                                                      }
                                                                      inputStyleDate={
                                                                        inputStyleDate
                                                                      }
                                                                      styleSelect={
                                                                        styleSelect
                                                                      }
                                                                      editorRef={
                                                                        editorRef
                                                                      }
                                                                      FIELD_DIMENSIONS={
                                                                        FIELD_DIMENSIONS
                                                                      }
                                                                      OnSymbol={
                                                                        OnSymbol
                                                                      }
                                                                      Offsymbol={
                                                                        Offsymbol
                                                                      }
                                                                      renderUsersOptions={
                                                                        renderUsersOptions
                                                                      }
                                                                      renderCategoriesOptions={
                                                                        renderCategoriesOptions
                                                                      }
                                                                      renderPeriodOptions={
                                                                        renderPeriodOptions
                                                                      }
                                                                      renderTermesOptions={
                                                                        renderTermesOptions
                                                                      }
                                                                      renderIndexationOptions={
                                                                        renderIndexationOptions
                                                                      }
                                                                      handleCguChange={
                                                                        handleCguChange
                                                                      }
                                                                      handleContratChange={
                                                                        handleContratChange
                                                                      }
                                                                      api={api}
                                                                      t={t}
                                                                    />

                                                                    {formik
                                                                      .touched[
                                                                      key
                                                                    ] &&
                                                                      formik
                                                                        .errors[
                                                                        key
                                                                      ] && (
                                                                        <div className="invalid-feedback d-block mt-1 small">
                                                                          {
                                                                            formik
                                                                              .errors[
                                                                              key
                                                                            ]
                                                                          }
                                                                        </div>
                                                                      )}
                                                                  </Col>
                                                                </Row>
                                                              </Col>
                                                            );
                                                          }
                                                        )}
                                                      </Row>
                                                    )
                                                  );
                                                })()
                                              : // Layout original pour les autres sections
                                                Object.entries(
                                                  subData || {}
                                                ).map(([key, value], index) => {
                                                  const isRequired =
                                                    isRequiredField(key);
                                                  const safeKey =
                                                    sanitizeSelector(
                                                      key.replace(
                                                        /([:])/g,
                                                        "\\$1"
                                                      )
                                                    );
                                                  return (
                                                    <div
                                                      key={key}
                                                      className="field-item px-2 py-1"
                                                      style={{
                                                        backgroundColor:
                                                          "white",
                                                        transition:
                                                          "all 0.15s ease",
                                                        borderLeft: isRequired
                                                          ? "3px solid #dc3545"
                                                          : "3px solid transparent",
                                                        position: "relative",
                                                      }}
                                                      onMouseEnter={(e) => {
                                                        if (isRequired) {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#ffe6e6";
                                                          e.currentTarget.style.borderLeftColor =
                                                            "#dc3545";
                                                        } else {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#e3f2fd";
                                                          e.currentTarget.style.borderLeftColor =
                                                            "#007bff";
                                                        }
                                                      }}
                                                      onMouseLeave={(e) => {
                                                        e.currentTarget.style.backgroundColor =
                                                          "white";
                                                        if (isRequired) {
                                                          e.currentTarget.style.borderLeftColor =
                                                            "#dc3545";
                                                        } else {
                                                          e.currentTarget.style.borderLeftColor =
                                                            "transparent";
                                                        }
                                                      }}
                                                    >
                                                      {/* Ligne de séparation */}
                                                      {index > 0 && (
                                                        <div
                                                          className="field-separator"
                                                          style={{
                                                            position:
                                                              "absolute",
                                                            top: "0",
                                                            left: "0",
                                                            right: "66%",
                                                            height: "1px",
                                                            background:
                                                              "linear-gradient(90deg, transparent 0%, #e9ecef 20%, #e9ecef 80%, transparent 100%)",
                                                          }}
                                                        />
                                                      )}

                                                      <Row className="align-items-center g-1">
                                                        <Col
                                                          xs={12}
                                                          md={4}
                                                          className="field-label"
                                                        >
                                                          <div className="d-flex align-items-center small text-muted">
                                                            <span
                                                              className={`fw-medium`}
                                                              style={{
                                                                fontSize:
                                                                  "0.8rem",
                                                                letterSpacing:
                                                                  "0.2px",
                                                              }}
                                                              id={`Tooltip-${safeKey}`}
                                                            >
                                                              {key}
                                                            </span>
                                                            {actionHelper
                                                              ?.result?.[
                                                              key
                                                            ] && (
                                                              <>
                                                                <span
                                                                  style={{
                                                                    display:
                                                                      "inline-flex",
                                                                    padding:
                                                                      "6px", // élargit la zone autour de l'icône
                                                                    cursor:
                                                                      "pointer",
                                                                    alignItems:
                                                                      "center",
                                                                    justifyContent:
                                                                      "center",
                                                                  }}
                                                                  id={`Info-${safeKey}`}
                                                                >
                                                                  <BsFillInfoCircleFill
                                                                    size={14}
                                                                    className="text-info"
                                                                  />
                                                                </span>
                                                                <Tooltip
                                                                  placement="right"
                                                                  isOpen={
                                                                    tooltipOpen[
                                                                      key
                                                                    ]
                                                                  }
                                                                  target={`Info-${safeKey}`}
                                                                  toggle={() =>
                                                                    toggleTooltip(
                                                                      key
                                                                    )
                                                                  }
                                                                  delay={{
                                                                    show: 0,
                                                                    hide: 100,
                                                                  }}
                                                                >
                                                                  {
                                                                    actionHelper
                                                                      ?.result[
                                                                      key
                                                                    ]
                                                                  }
                                                                </Tooltip>
                                                              </>
                                                            )}
                                                            <span className="ms-1 text-primary">
                                                              :
                                                            </span>
                                                          </div>
                                                        </Col>

                                                        <Col
                                                          xs={12}
                                                          md={8}
                                                          className="field-input"
                                                        >
                                                          <DynamicFieldRenderer
                                                            fieldKey={key}
                                                            formik={formik}
                                                            isRequired={
                                                              isRequired
                                                            }
                                                            inputStyle={
                                                              inputStyle
                                                            }
                                                            inputStyleDate={
                                                              inputStyleDate
                                                            }
                                                            styleSelect={
                                                              styleSelect
                                                            }
                                                            editorRef={
                                                              editorRef
                                                            }
                                                            FIELD_DIMENSIONS={
                                                              FIELD_DIMENSIONS
                                                            }
                                                            OnSymbol={OnSymbol}
                                                            Offsymbol={
                                                              Offsymbol
                                                            }
                                                            renderUsersOptions={
                                                              renderUsersOptions
                                                            }
                                                            renderCategoriesOptions={
                                                              renderCategoriesOptions
                                                            }
                                                            renderPeriodOptions={
                                                              renderPeriodOptions
                                                            }
                                                            renderTermesOptions={
                                                              renderTermesOptions
                                                            }
                                                            renderIndexationOptions={
                                                              renderIndexationOptions
                                                            }
                                                            handleCguChange={
                                                              handleCguChange
                                                            }
                                                            handleContratChange={
                                                              handleContratChange
                                                            }
                                                            api={api}
                                                            t={t}
                                                          />

                                                          {formik.touched[
                                                            key
                                                          ] &&
                                                            formik.errors[
                                                              key
                                                            ] && (
                                                              <div className="invalid-feedback d-block mt-1 small">
                                                                {
                                                                  formik.errors[
                                                                    key
                                                                  ]
                                                                }
                                                              </div>
                                                            )}
                                                        </Col>
                                                      </Row>
                                                    </div>
                                                  );
                                                })}
                                          </div>
                                        </CardBody>
                                      </Collapse>
                                    </Card>
                                  </Col>
                                ))}
                              </Row>
                            ) : (
                              <div
                                style={{
                                  position: "fixed",
                                  top: "50%",
                                  left: "50%",
                                  transform: "translate(-50%, -50%)",
                                }}
                              >
                                <Spinner color="primary" />
                              </div>
                            )}
                            <div ref={formEndRef} style={{ height: "1px" }} />
                          </div>
                        )
                    )}

                    <FloatingFormActions
                      showFloatingButtons={showFloatingButtons}
                      leftPosition={leftPosition}
                      onCancel={toggleEditMode}
                      onSubmit={formik.handleSubmit}
                      isSubmitting={formik.isSubmitting}
                      disabled={!formik.isValid}
                      submitText={t("Enregistrer les modifications")}
                    />
                  </CardBody>
                </Card>
              </>
            )}
          </Col>
        </Row>
      </div>
      <ToastContainer />
    </>
  );
}

export default FxFacturationDetail;
